<style scoped lang="scss">
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .compose-type1{
    padding-bottom: 50px;
    //background: url("../../assets/images/molecular/fuys_bj.png") no-repeat;
    //background-size: 100% 100%;
  }
  .required{
    background: none!important;
    margin-left: 0!important;
    margin-top: 80px;
  }
  .desc{
    font-size: 16px;
  }
  .effect-lists{
    //display: block!important;
    justify-content: flex-start;
    flex-wrap:wrap;
    overflow: auto;
  }
  .effect-lists li{
    margin-right: 30px!important;
    float: left!important;
    width: 22.3% !important;
  }
  .effect-lists li:nth-child(4n){
    margin-right: 0;
  }
  .cons{
    display: none;
  }

</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner con">
      <img src="@/assets/img/产品及服务/DNA提取+PCR扩增+测序/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons">
      <img src="@/assets/img/二级标题Banner/DNA提取+PCR扩增+测序banner.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section class="container">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <p class="desc" style="font-weight:bold;color: #014492;margin-bottom: 10px;">DNA提取+PCR扩增+测序</p>
      <p class="desc" style="margin-bottom: 10px;">擎科生物依托现有的自动化LIMS管理系统，自动化磁珠法纯化平台，自动化 PCR 反应纯化等分子生物学研发设备平台和拥有多年项目经验的科研团队，可提供DNA提取+PCR扩增+测序等一站式技术服务，针对不同的样本类型，制定个性化的实验方案，交付高质量的科研结果。</p>
      <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">服务流程<small>Service process</small></div>
        <img src="@/assets/img/产品及服务/DNA提取+PCR扩增+测序/服务流程.png" class="img-fluid">
      </div>
      <div class="container cons">
        <div class="c-title">服务流程<small>Service process</small></div>
        <img src="@/assets/img/产品及服务/DNA提取+PCR扩增+测序/服务流程.png" class="img-fluid">
      </div>
      <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">实验方法<small>Experimental methods</small></div>
        <p class="desc" style="margin-bottom: 10px;font-weight:bold;text-indent: 0em">DNA 提取</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">( a ) 根据不同的样本类型，选取不同的试剂盒，如：植物多糖多酚样本、石蜡样本、毛囊样本、均采用不同的试剂盒和实验方案。</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">( b ) 若样本较多，则采取自动化提取仪提取 DNA。</p>
        <p class="desc" style="margin-bottom: 10px;font-weight:bold;text-indent: 0em">PCR 扩增</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">根据不同的样品及DNA序列情况，选取不同的扩增程序和PCR Mix，使用本公司研发针对高保真，高级结构，超长片段的PCR Mix，可实现在30min内完成一次PCR实验，拥有多台PCR仪，能够高效完成PCR扩增实验。</p>
        <p class="desc" style="margin-bottom: 10px;font-weight:bold;text-indent: 0em">DNA 测序</p>
        <p class="desc" style="text-indent: 0em">擎科生物是采用以磁珠为依托的半自动测序流程的生物公司。相比较传统膜纯化方法，采用磁珠方法可大幅度提高模板纯度和浓度，有效避免信号弱，信号衰减，甚至无信号的风险，测序成功率为国内领先水平。</p>
      </div>
      <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">擎科交付<small>Tsingke delivery</small></div>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">1.提供测序结果统计表；</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">2.提供原始检测峰图；</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">3.提供扩增测序报告。</p>
      </div>
      <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">应用案例<small>Application case</small></div>
        <p class="c-title1" style="font-size: 16px;margin-bottom: 10px;">困难模板，高 GC 模板优化测序案例</p>
        <img src="@/assets/img/产品及服务/DNA提取+PCR扩增+测序/应用案例.png" class="img-fluid">
      </div>
      <div class="container cons" >
        <div class="c-title">实验方法<small>Experimental methods</small></div>
        <p class="desc" style="margin-bottom: 10px;font-weight:bold;text-indent: 0em">DNA 提取</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">( a ) 根据不同的样本类型，选取不同的试剂盒，如：植物多糖多酚样本、石蜡样本、毛囊样本、均采用不同的试剂盒和实验方案。</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">( b ) 若样本较多，则采取自动化提取仪提取 DNA。</p>
        <p class="desc" style="margin-bottom: 10px;font-weight:bold;text-indent: 0em">PCR 扩增</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">根据不同的样品及DNA序列情况，选取不同的扩增程序和PCR Mix，使用本公司研发针对高保真，高级结构，超长片段的PCR Mix，可实现在30min内完成一次PCR实验，拥有多台PCR仪，能够高效完成PCR扩增实验。</p>
        <p class="desc" style="margin-bottom: 10px;font-weight:bold;text-indent: 0em">DNA 测序</p>
        <p class="desc" style="text-indent: 0em">擎科生物是采用以磁珠为依托的半自动测序流程的生物公司。相比较传统膜纯化方法，采用磁珠方法可大幅度提高模板纯度和浓度，有效避免信号弱，信号衰减，甚至无信号的风险，测序成功率为国内领先水平。</p>
      </div>
      <div class="container cons" >
        <div class="c-title">擎科交付<small>Tsingke delivery</small></div>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">1.提供测序结果统计表；</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">2.提供原始检测峰图；</p>
        <p class="desc" style="margin-bottom: 10px;text-indent: 0em">3.提供扩增测序报告。</p>
      </div>
      <div class="container cons" >
        <div class="c-title">应用案例<small>Application case</small></div>
        <p class="c-title1" style="font-size: 16px;margin-bottom: 10px;">困难模板，高 GC 模板优化测序案例</p>
        <img src="@/assets/img/产品及服务/DNA提取+PCR扩增+测序/应用案例.png" class="img-fluid">
      </div>
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="c-title">相关服务与产品<small>Related services and products</small></div>
      <div class="con">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1"  @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`">
            <p style="margin-top: 10px;">{{item.name}}</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)">
            <img :src="`/static/img/Project_${item.img}${currentType===index ? '' : ''}.png`" style="width: 55px;height: 55px;">
            <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
          </li>
        </ul>
      </div>
        <qk-consult type="Virus"/>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        // {name: '分子试剂', img: '11', ref: '/equipment/Molecular_reagent'},
        {name: 'SSR/STR检测', img: '4', ref: '/tec/SSR'},
        {name: 'SNP检测', img: '5', ref: '/tec/SNP'},
        {name: '特定基因检测', img: '6', ref: '/tec/specific'},
        {name: '荧光定量PCR', img: '7', ref: '/tec/qPCR'},
        {name: '菌种鉴定', img: '8', ref: '/tec/rDNA'},
        ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/DNA_tiqu.vue